<template>
  <div v-if="isAuthenticated" class="card mb-4">
    <div class="card-header">
      <h5 class="mb-0">
        <i class="bi bi-trophy me-2"></i>My Achievements
      </h5>
    </div>
    <div class="card-body">
      <div class="achievement-summary">
        <div class="achievement-item">
          <div class="achievement-icon bg-primary">
            <i class="bi bi-star-fill"></i>
          </div>
          <div class="achievement-text">
            <div class="achievement-value">{{ userAchievements.points }}</div>
            <small>Points</small>
          </div>
        </div>
        <div class="achievement-item">
          <div class="achievement-icon bg-success">
            <i class="bi bi-award-fill"></i>
          </div>
          <div class="achievement-text">
            <div class="achievement-value">Lv.{{ userAchievements.level }}</div>
            <small>Level</small>
          </div>
        </div>
      </div>
      
      <div class="badges-section mt-3">
        <h6 class="mb-2">Badge Collection</h6>
        <div class="badges-grid">
          <div 
            v-for="badge in userAchievements.badges" 
            :key="badge"
            class="badge-item"
            :title="badge"
          >
            <i class="bi bi-award-fill"></i>
          </div>
          <div v-if="userAchievements.badges.length === 0" class="text-muted small">
            No badges yet, start interacting to earn them!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAchievements',
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true
    },
    userAchievements: {
      type: Object,
      default: () => ({
        points: 0,
        level: 1,
        badges: []
      })
    }
  }
}
</script>

<style scoped>
/* Achievement Section */
.achievement-summary {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.achievement-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
}

.achievement-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.achievement-value {
  font-weight: bold;
  font-size: 1.1rem;
}

.badges-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.badge-item {
  width: 30px;
  height: 30px;
  background: #ffd700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #856404;
}
</style>